import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { environment } from "../../../environments/environment";
import { SentryObserve } from "./sentry-observe";

export class SentryInit {
  private static initEnd = false;

  /** Sentryの監視処理の開始 */
  private static init() {
    console.log('Sentry.init');
    this.initEnd = true;

    Sentry.init({
      dsn: "https://6a0ee237db744697a9f8615a698fc4f4@o919485.ingest.sentry.io/5863659",
      integrations: [
        new Integrations.BrowserTracing({
          tracingOrigins: ["localhost", "https://yourserver.io/api"],
          routingInstrumentation: Sentry.routingInstrumentation,
        }),
      ],
      tracesSampleRate: 1.0,
      environment: environment.name,
      autoSessionTracking: false,
    });
    SentryObserve.sentryObserveStart();
  }

  /** Sentryの監視処理を開始するユーザーかどうか判定する */
  public static checkSentryInit() {
    if (SentryInit.initEnd || SentryObserve.sentryObserveUsername === null) {
      return;
    }
    const targets: string[] = SentryObserve.sentryObserveUsername.split(',');
    const tokenUsername: string = localStorage.getItem(`CognitoIdentityServiceProvider.${environment.amplify.Auth.userPoolWebClientId}.LastAuthUser`);
    if (targets.length >= 1 && targets.some(username => username === tokenUsername)) {
      this.init();
    }
  }
}
